/* TSURATSURA リニューアル 2026.07 — 共通スクリプト（全て要素存在チェック付き） */
(function () {
  'use strict';

  /* ---------- テーマエディタ内: アニメーション無効・常時表示（真っ白対策） ---------- */
  if (window.Shopify && window.Shopify.designMode) {
    var ds = document.createElement('style');
    ds.textContent =
      '.rn-loader{display:none!important}' +
      '.ts-rn .rv,.ts-rn .chip,.ts-rn .str,.ts-rn .gno,.ts-rn .rn-media,.ts-rn .fs,' +
      '.ts-rn .flow .f,.ts-rn .flow .a,' +
      '.ts-rn .svc .body h2,.ts-rn .svc .body .en,.ts-rn .svc .body > p,.ts-rn .svc .body .foot' +
      '{opacity:1!important;transform:none!important}' +
      '.ts-rn .const .ring{stroke-dashoffset:0!important}' +
      '.ts-rn .const .node,.ts-rn .const .halo,.ts-rn .const text,.ts-rn .const .comet{opacity:1!important}' +
      '.ts-rn .fs-line{transform:none!important}' +
      '.ts-rn .ph-rev{clip-path:none!important}';
    document.head.appendChild(ds);
  }

  /* ---------- ローディング: ポリゴン生成アニメーション ---------- */
  var lcv = document.getElementById('rnLoaderPoly');
  if (lcv && !lcv.closest('.rn-loader').classList.contains('skip')) {
    var lcx = lcv.getContext('2d');
    var LW = lcv.width = lcv.offsetWidth * devicePixelRatio;
    var LH = lcv.height = lcv.offsetHeight * devicePixelRatio;
    var lnodes = [];
    for (var li = 0; li < 42; li++) {
      lnodes.push({
        x: Math.random(), y: Math.random(),
        vx: (Math.random() - 0.5) * 0.0012, vy: (Math.random() - 0.5) * 0.0012,
        lamp: Math.random() < 0.2
      });
    }
    /* タグラインを1文字ずつ浮かび上がらせる */
    var tl = document.getElementById('rnLoaderTagline');
    if (tl) {
      var text = tl.dataset.text || '';
      var accent = tl.dataset.accent || '';
      var ai = accent ? text.indexOf(accent) : -1;
      for (var ci = 0; ci < text.length; ci++) {
        var sp = document.createElement('span');
        sp.textContent = text[ci];
        if (ai >= 0 && ci >= ai && ci < ai + accent.length) sp.className = 'accent';
        tl.appendChild(sp);
      }
      var spans = tl.children;
      Array.prototype.forEach.call(spans, function (sp2, k) {
        setTimeout(function () { sp2.classList.add('on'); }, 800 + k * 85);
      });
      setTimeout(function () { tl.classList.add('out'); }, 4100);
    }

    var lt0 = performance.now();
    (function ltick(t) {
      var el = (t - lt0) / 1000;
      if (el > 8.5) return; // 退場後は停止
      lcx.clearRect(0, 0, LW, LH);
      // 接続距離が 0→0.2 に育つ = 点が繋がっていく
      var prog = Math.min(1, el / 2);
      var eased = 1 - Math.pow(1 - prog, 3);
      var D = 0.2 * eased;
      lnodes.forEach(function (n) {
        n.x += n.vx; n.y += n.vy;
        if (n.x < 0 || n.x > 1) n.vx *= -1;
        if (n.y < 0 || n.y > 1) n.vy *= -1;
      });
      for (var i = 0; i < lnodes.length; i++)
        for (var j = i + 1; j < lnodes.length; j++) {
          var a = lnodes[i], b = lnodes[j];
          var d = Math.hypot(a.x - b.x, a.y - b.y);
          if (d < D) {
            var o = (1 - d / D) * eased;
            lcx.strokeStyle = (a.lamp || b.lamp)
              ? 'rgba(232,163,29,' + (o * 0.5) + ')'
              : 'rgba(248,245,236,' + (o * 0.22) + ')';
            lcx.lineWidth = 1;
            lcx.beginPath(); lcx.moveTo(a.x * LW, a.y * LH); lcx.lineTo(b.x * LW, b.y * LH); lcx.stroke();
          }
        }
      lnodes.forEach(function (n, k) {
        var appear = Math.min(1, Math.max(0, (el - k * 0.012) / 0.4));
        lcx.beginPath();
        lcx.arc(n.x * LW, n.y * LH, (n.lamp ? 2.6 : 1.7) * devicePixelRatio, 0, 7);
        lcx.fillStyle = n.lamp
          ? 'rgba(232,163,29,' + (0.9 * appear) + ')'
          : 'rgba(248,245,236,' + (0.5 * appear) + ')';
        lcx.fill();
      });
      requestAnimationFrame(ltick);
    })(lt0);
  }

  /* ---------- スクロール・リビール ---------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.ts-rn .rv, .ts-rn .step, .ts-rn .const, .ts-rn .flow, .ts-rn .svc, .ts-rn .fsteps, .ts-rn .slices').forEach(function (el) { io.observe(el); });

  /* ---------- ヒーロー背景スライド ---------- */
  var slidesWrap = document.getElementById('rnHeroSlides');
  if (slidesWrap) {
    var slides = slidesWrap.querySelectorAll('img');
    if (slides.length > 1) {
      var cur = 0;
      setInterval(function () {
        slides[cur].classList.remove('active');
        cur = (cur + 1) % slides.length;
        slides[cur].classList.add('active');
      }, 6000);
    }
  }

  /* ---------- ポリゴン・ネットワーク（data-rn-poly の canvas 全て） ---------- */
  document.querySelectorAll('canvas[data-rn-poly]').forEach(function (cv) {
    var cx = cv.getContext('2d');
    var W, H, nodes = [];
    var nightX = parseFloat(cv.dataset.nightX || '0.62');
    var count = parseInt(cv.dataset.count || '40', 10);
    var fills = cv.dataset.fills !== 'false';
    function resize() {
      W = cv.width = cv.offsetWidth * devicePixelRatio;
      H = cv.height = cv.offsetHeight * devicePixelRatio;
    }
    resize(); addEventListener('resize', resize);
    var N = Math.min(count, Math.floor(innerWidth / 28));
    for (var i = 0; i < N; i++) {
      nodes.push({
        x: Math.random(), y: Math.random(),
        vx: (Math.random() - 0.5) * 0.0006, vy: (Math.random() - 0.5) * 0.0006,
        lamp: Math.random() < 0.18, dim: Math.random() < 0.5
      });
    }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
    function visible(n) { return !(n.dim && n.x > nightX); }
    (function tick() {
      cx.clearRect(0, 0, W, H);
      var D = 0.16;
      nodes.forEach(function (n) {
        n.x += n.vx; n.y += n.vy;
        if (n.x < 0 || n.x > 1) n.vx *= -1;
        if (n.y < 0 || n.y > 1) n.vy *= -1;
      });
      if (fills) {
        for (var i = 0; i < nodes.length; i++)
          for (var j = i + 1; j < nodes.length; j++)
            for (var k = j + 1; k < nodes.length; k++) {
              var a = nodes[i], b = nodes[j], c = nodes[k];
              if (!visible(a) || !visible(b) || !visible(c)) continue;
              if ((a.x + b.x + c.x) / 3 > nightX) continue;
              if (dist(a, b) < D && dist(b, c) < D && dist(a, c) < D) {
                cx.beginPath();
                cx.moveTo(a.x * W, a.y * H); cx.lineTo(b.x * W, b.y * H); cx.lineTo(c.x * W, c.y * H);
                cx.closePath();
                cx.fillStyle = 'rgba(24,39,87,0.014)';
                cx.fill();
              }
            }
      }
      for (var i2 = 0; i2 < nodes.length; i2++)
        for (var j2 = i2 + 1; j2 < nodes.length; j2++) {
          var a2 = nodes[i2], b2 = nodes[j2];
          if (!visible(a2) || !visible(b2)) continue;
          var d2 = dist(a2, b2);
          if (d2 < D) {
            var o = (1 - d2 / D);
            var onNight = (a2.x + b2.x) / 2 > nightX;
            cx.strokeStyle = (a2.lamp || b2.lamp)
              ? 'rgba(232,163,29,' + (o * (onNight ? 0.18 : 0.3)) + ')'
              : (onNight ? 'rgba(248,245,236,' + (o * 0.08) + ')' : 'rgba(24,39,87,' + (o * 0.11) + ')');
            cx.lineWidth = 1;
            cx.beginPath(); cx.moveTo(a2.x * W, a2.y * H); cx.lineTo(b2.x * W, b2.y * H); cx.stroke();
          }
        }
      nodes.forEach(function (n) {
        if (!visible(n)) return;
        var onNight = n.x > nightX;
        cx.beginPath();
        cx.arc(n.x * W, n.y * H, (n.lamp ? 2.6 : 1.7) * devicePixelRatio, 0, 7);
        cx.fillStyle = n.lamp
          ? 'rgba(232,163,29,' + (onNight ? 0.6 : 0.85) + ')'
          : (onNight ? 'rgba(248,245,236,.25)' : 'rgba(24,39,87,.28)');
        cx.fill();
      });
      requestAnimationFrame(tick);
    })();
  });

  /* ---------- 星（CONTACT） ---------- */
  document.querySelectorAll('canvas[data-rn-stars]').forEach(function (sc) {
    var sx = sc.getContext('2d');
    var SW, SH, stars = [];
    function sResize() {
      SW = sc.width = sc.offsetWidth * devicePixelRatio;
      SH = sc.height = sc.offsetHeight * devicePixelRatio;
      stars = [];
      for (var i = 0; i < 36; i++) {
        stars.push({
          x: Math.random() * SW, y: Math.random() * SH * 0.8,
          r: (Math.random() * 1.5 + 0.5) * devicePixelRatio,
          p: Math.random() * Math.PI * 2, s: 0.007 + Math.random() * 0.018
        });
      }
    }
    sResize(); addEventListener('resize', sResize);
    (function sTick() {
      sx.clearRect(0, 0, SW, SH);
      stars.forEach(function (st) {
        st.p += st.s;
        var o = 0.22 + Math.abs(Math.sin(st.p)) * 0.52;
        sx.beginPath(); sx.arc(st.x, st.y, st.r, 0, 7);
        sx.fillStyle = 'rgba(243,206,107,' + o + ')';
        sx.fill();
      });
      requestAnimationFrame(sTick);
    })();
  });

  /* ---------- 数字カウントアップ ---------- */
  var nio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      nio.unobserve(e.target);
      var el = e.target, target = +el.dataset.n, suf = el.dataset.suffix || '';
      var t0 = performance.now(), dur = 1600;
      (function step(t) {
        var p = Math.min(1, (t - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.innerHTML = Math.round(target * eased) + (suf ? '<small>' + suf + '</small>' : '');
        if (p < 1) requestAnimationFrame(step);
      })(t0);
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('.ts-rn .band-stats .num').forEach(function (el) { nio.observe(el); });

  /* ---------- ケーススタディ・スライダー ---------- */
  var track = document.getElementById('rnCaseTrack');
  if (track) {
    var dots = document.querySelectorAll('#rnCaseDots button');
    var total = track.children.length;
    var cIdx = 0, caseTimer = null;
    var goCase = function (i) {
      cIdx = (i + total) % total;
      track.style.transform = 'translateX(-' + (cIdx * 100) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('act', k === cIdx); });
    };
    var resetCase = function () {
      if (caseTimer) clearInterval(caseTimer);
      caseTimer = setInterval(function () { goCase(cIdx + 1); }, 8000);
    };
    var prev = document.getElementById('rnCasePrev'), next = document.getElementById('rnCaseNext');
    if (prev) prev.addEventListener('click', function () { goCase(cIdx - 1); resetCase(); });
    if (next) next.addEventListener('click', function () { goCase(cIdx + 1); resetCase(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { goCase(+d.dataset.i); resetCase(); }); });
    if (total > 1) resetCase();
  }

  /* ---------- サービス: メディアのゆるいパララックス ---------- */
  var phs = document.querySelectorAll('.ts-rn .rn-media .ph, .ts-rn .rn-media .brand-tile');
  if (phs.length) {
    addEventListener('scroll', function () {
      phs.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        var c = r.top + r.height / 2 - innerHeight / 2;
        el.style.transform = 'translateY(' + (c * -0.05) + 'px)';
      });
    }, { passive: true });
  }

  /* ---------- モバイルナビ ---------- */
  var mbtn = document.getElementById('rnMenuBtn');
  if (mbtn) {
    mbtn.addEventListener('click', function () {
      var nav = document.getElementById('rnNav');
      if (nav) nav.classList.toggle('open');
    });
  }
})();
